<template>
    <div :class="classNamesElement">
        <label :for="id" v-if="label"><translate>{{ label }}</translate></label>
        <textarea class="form-input textarea" :name="id" :id="id" :value="modelValue"
               @input="$emit('update:modelValue', $event.target.value)" ref="input" :placeholder="placeholder"
               :required="required" :autofocus="autofocus" :autocomplete="autocomplete" :disabled="disabled" :style="{'height': inputHeight }"></textarea>
        <svg-vue v-if="icon" :icon="icon" class="icon" />
        <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
    </div>
</template>

<script>
export default {
    name: 'FormText',
    props: [
        'modelValue',
        'id',
        'type',
        'label',
        'placeholder',
        'required',
        'autofocus',
        'autocomplete',
        'error',
        'info',
        'disabled',
        'icon',
        'height',
    ],
    computed: {
        classNamesElement() {
            let classNames = ['form-element'];
            if (this.error) classNames.push('form-element--error');
            if (!this.error && this.modelValue) classNames.push('form-element--valid');
            if (this.icon) classNames.push('form-element--icon');
            if (this.modelValue) classNames.push('form-element--filled');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : this.info;
        },
        inputHeight() {
            return this.height ? this.height : '100px';
        },
    },
    emits: ['update:modelValue'],
    methods: {
        focus() {
            this.$refs.input.focus();
        }
    }
};
</script>
